import {_, React, observer, observable, computed, IDisposer, action, useLocalStore, useEffect, useLayoutEffect, classNames, useAsObservableSource, Popover2, Fragment} from '@api'
import {Button, Icon, Menu, MenuItem} from '@blueprintjs/core'
import {ToolbarChip, useStores, useVipLocalStore, VipLocalStore} from '@modules'
import {IServerRenderedPDFTemplateDefinition, IServerRenderedPDFTemplateInstance, PDFServerRenderedContainerStore, usePDFServerRenderedContainerStore} from '@modules/pdf'
import {PDFArtifactDropdown, QUERY_KEY_PDF_ARTIFACTS} from '@modules/pdf/serverRenderedPDF/components/PDFArtifactDropdown'
import {StoresInstance} from '@stores'
import {PdfSvgIcon} from '@stores/ui'
import {PrimaryIconButton} from 'centric-ui-components'
import * as css from './PDFViewerToolbar.css'

/// region Store

export class PDFTemplatePickerStore extends VipLocalStore {
  constructor(stores: StoresInstance, public props: Omit<MyProps, 'className'>) {
    super(stores)
  }

  get container() { return this.stores.cloudPDF.component}
  registerEffects = () => {
    const _toDispose: Array<IDisposer> = []

    return () => {
      _toDispose.forEach(d => d())
    }
  }

  @action onSelectTemplate = (template: IServerRenderedPDFTemplateDefinition) => (e) => {
    this.catalog.settings.pdf.selectedTemplate = template.template
  }

  @action deleteCurrentPDF = async () => {
    const {container: {selectedPdf}, axiosNest, cloudPDF: {invalidateArtifacts}} = this
    if (selectedPdf) {
      await axiosNest.delete(`/pdf/artifact/${selectedPdf.entry._id}`)
      this.container.selectedPdf = null
      await invalidateArtifacts()
    }
  }

  @action refreshEntries = async () => {
    await this.container.queryClient.invalidateQueries(QUERY_KEY_PDF_ARTIFACTS)
  }
}

export const PDFTemplatePickerStoreContext = React.createContext<PDFTemplatePickerStore>(null)
export const usePDFTemplatePickerStore = () => React.useContext(PDFTemplatePickerStoreContext)

/// endregion

/// region Components

interface MyProps {
  className?: string
}

export const PDFViewerToolbar = observer<MyProps>(function PDFViewerToolbar({className, ...props}) {
  const obsProps = useAsObservableSource({...props}),
    store = useVipLocalStore((stores) => new PDFTemplatePickerStore(stores, obsProps)),
    {onSelectTemplate, deleteCurrentPDF, cloudPDF: {availableTemplates}, container, refreshEntries} = store,
    m = useStores()

  useEffect(() => store.registerEffects(), [])

  return (
    <PDFTemplatePickerStoreContext.Provider value={store}>
      <div className={classNames(css.root, className)}>
        <label>Available PDFs:</label>

        <PDFArtifactDropdown/>
        <div className={css.buttons}>
          {container?.selectedPdf && <Fragment>
            <PrimaryIconButton icon='link' tooltip='Open in New Tab' tooltipStyle='mui' tooltipPosition='bottom' target='_blank' href={container?.selectedPdf?.url}/>
            <PrimaryIconButton showOnHover icon='trash' tooltip='Delete PDF' tooltipStyle='mui' tooltipPosition='bottom' onClick={deleteCurrentPDF} />
          </Fragment>}
          <PrimaryIconButton showOnHover icon='refresh' tooltip='Refresh' tooltipStyle='mui' tooltipPosition='bottom' onClick={refreshEntries}/>
        </div>
        {/*<Button text='Generate PDF' onClick={container?.generatePDF} />*/}
      </div>
    </PDFTemplatePickerStoreContext.Provider>)
})

/// endregion


/*
<Button
            icon={<PdfSvgIcon/>}
            rightIcon='caret-down'
            text={selectedTemplate?.text ?? 'Chose template...'}
          />
 */


// WEBPACK FOOTER //
// ./src/modules/pdf/serverRenderedPDF/components/PDFViewerToolbar.tsx